import { Comparativa } from "./Comparativa";
import { ComparativaExpendedora } from "./ComparativaExpendedora";
import { TotalProducto } from "./TotalProducto";

export class Comparativas{
    comparativas: Comparativa[];
    comparativasExpendedoras: ComparativaExpendedora[];
    totalesProductos: TotalProducto[];
}

